import { ColorsFasciaGroups, GroupAlign, TextAlign, TextColor, TextSize, TextType } from '@as/cotopaxi';
export const aemColorToCotopaxiColor = {
    contrast: 'N300',
    'high-contrast': 'N700',
    accent: ColorsFasciaGroups.DIVIDER_LIST,
    neutral: 'N100',
    'neutral-accent': 'N200',
    'accent-primary': ColorsFasciaGroups.DIVIDER_LIST,
    dark: 'N700',
    'medium-lighter': 'N200',
    'medium-darker': 'N300',
    light: 'N100',
};
export const mapTextColorToDividerLineColor = {
    'accent-primary': 'dark',
    dark: 'dark',
    'medium-lighter': 'neutral',
    'medium-darker': 'neutral',
    light: 'neutral',
};
export const mapListItemTextSize = {
    small: TextSize.SMALL,
    medium: TextSize.MEDIUM,
    large: TextSize.LARGE,
};
export const mapGroupAlign = {
    left: undefined,
    center: GroupAlign.CENTER,
    right: GroupAlign.RIGHT,
};
export const mapStackJustify = {
    left: 'start',
    center: 'center',
    right: 'end',
};
// Text component migration utilities
export const mapTextSizeToVariant = {
    [TextSize.XLARGE]: 'bodyXL',
    [TextSize.LARGE]: 'bodyL',
    [TextSize.MEDIUM]: 'bodyM',
    [TextSize.SMALL]: 'bodyS',
    [TextSize.XSMALL]: 'bodyXS',
    [TextSize.INHERIT]: 'inherit',
};
export const mapTextTypeToVariant = {
    [TextType.EXTRA_LARGE_CONTENT]: 'body2XL',
    [TextType.EXTRA_CONTENT]: 'bodyL',
    [TextType.LARGE_CONTENT]: 'bodyL',
    [TextType.CONTENT]: 'bodyM',
    [TextType.SUB_CONTENT]: 'bodyS',
    [TextType.TITLE]: 'subheadingM',
};
export const mapTextColorToColor = {
    [TextColor.NEGATIVE]: 'error',
    [TextColor.POSITIVE]: 'success',
    [TextColor.SUBTLE]: 'subtle',
    [TextColor.DISCOUNT]: 'commercial',
    [TextColor.INHERIT]: 'current',
    [TextColor.INFO]: 'informative',
    [TextColor.NOTICE]: 'warning',
    [TextColor.INVERSE]: 'inverse',
};
export const mapTextAlignToAlignment = {
    [TextAlign.CENTER]: 'center',
    [TextAlign.RIGHT]: 'end',
    [TextAlign.LEFT]: 'start',
};
export const mapAemColorToAndesColor = {
    contrast: 'subtle',
    'high-contrast': 'neutral',
    accent: 'brand',
    neutral: 'inverse',
    'neutral-accent': 'quiet',
    'accent-primary': 'brand',
    dark: 'neutral',
    'medium-lighter': 'quiet',
    'medium-darker': 'subtle',
    light: 'inverse',
};
